import React, { memo, useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import Amount from 'design-system/Amount';
import { rem } from 'design-system/values';
import { TextButtonLink } from 'design-system';
import { useMainStackNavigation } from 'utils/types/navigationV6';
const AnalyticsSectionHeader = ({ id, title, amount, currency, hideRightSection }) => {
    const navigation = useMainStackNavigation();
    const onManageExcluded = useCallback(() => {
        navigation.navigateDeprecated('ExcludeCategories', { fromAnalytics: true });
    }, []);
    return (<View style={styles.container}>
      <Text Text-16 Secondary flex>
        {title}
      </Text>
      {!hideRightSection &&
            (id === 'excluded' ? (<TextButtonLink text="Manage" onPress={onManageExcluded}/>) : (<Amount showSign Numbers-16 value={{ value: amount, currency }} {...(amount > 0 && id !== 'income'
                ? { Blue: true }
                : { Secondary: true })}/>))}
    </View>);
};
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        marginHorizontal: rem(16),
        marginTop: rem(24),
        marginBottom: rem(16),
    },
});
export default memo(AnalyticsSectionHeader);
